<<template>  
  <prop-panel @close="close">
    <p slot="header">{{rs["iPrint"]}}</p>
    
    <div class="row" style="margin-left:0">
      <div  style="margin: 1px; height: 190px;">
        <div class="input-group col-md-10">
          <input ref="gnNo" v-model="gnNo" @keyup.enter="onEnter" type="text" class="form-control">
          <div class="input-group-btn">
            <button @click.stop="onEnter" class="btn btn-default">添加</button>
            <button @click.stop="clear" class="btn btn-default">清除全部</button>
          </div>
        </div>
        <select size="10" style="width: 500px; height: 150px; margin-left:17px;">
          <option v-for="(item, idx) in gnList" :value="item.empId" @dblclick.stop="removeItem(idx)">{{item.empId}}  {{item.empName}}</option>
        </select>
      </div>
    </div>
    <div slot="footer">
      <button @click.stop="close" type="button" class="btn btn-default" data-dismiss="modal">{{rs["btn_close"]}}</button>
      <button @click.stop="generate" type="button" class="btn btn-primary">{{rs["print"]}}</button>
    </div>
  </prop-panel>
</template>

<<script>
export default {
  created: function() {
    //const dt = this.$dateNow()
    //this.rq1=this.bdate
    //this.rq2=this.edate
  },
  props:["config","rs"],
  data(){
    return {
      gnTarget: 1,
      gnLock: null,
      gnType:1,
      gnNo: null,
      gnList:[],
      dept: null
    }
  },
  methods:{
    close: function() {
      this.$emit("closeBP")
    },
    onEnter(){
      const dt = this.gnList.filter(d=>{
        return d.bh==this.gnNo || d.xm==this.gnNo
      })
      if (dt.length>0) {
        this.$refs.gnNo.select()
        return
      } 
      this.$getData("attendance/GetUser?No=" + this.gnNo, data=>{
        if (data.rs==1){
          this.gnList.push(data.emp)
          this.gnNo=""
        }
        else{
          this.$alert(this.rs["notFound"])
          this.$refs.gnNo.select()
        }
      })
    },
    removeItem(idx){
        this.gnList.splice(idx,1)
    },
    clear(){
      this.gnList = []
      this.$refs.gnNo.select()
    },
    generate(){
      if (this.gnList.length<=0) return
      const arr = []
      this.gnList.forEach(d=>{
        arr.push(d.empId)
      })
      
      this.$postData("report/MakeICard", arr, data=>{
        if (data.rs==1) window.open(this.$apiUrl + "fm/download?fileName=" + data.file)
      })
    }
  }
}
</script>
